import { render, staticRenderFns } from "./dividends.vue?vue&type=template&id=47c8778b&scoped=true&"
import script from "./dividends.vue?vue&type=script&lang=js&"
export * from "./dividends.vue?vue&type=script&lang=js&"
import style0 from "./dividends.vue?vue&type=style&index=0&id=47c8778b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8778b",
  null
  
)

export default component.exports